<template>
  <div class="main">
    <Header/>
    <div class="content">
      <Logo :subTitle="typeRetirementText" description="" />
      <RetirementRequest ref="retirementComponent" 
        v-on:get-type-retirement="getResponseRetirement($event)" />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header/Header.vue'
import RetirementRequest from '@/components/Retirement/RetirementRequest.vue'
import Logo from '@/components/PreRequestLoan/Logo.vue'

export default {
  data() {
    return {
      typeRetirementText: "Solicitud de Retiro",
    }
  },
  name: 'RetirementRequestView',
  components: {
    Header,
    RetirementRequest,
    Logo
  },
  methods: {
    getResponseRetirement(event) {
      this.typeRetirementText = event;
      console.log(event);
    }
  }
}
</script>

<style scoped>
.main {
  @apply grid grid-cols-1 gap-4;
}
.content {
  padding:30px;
}
</style>